import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';

import connect from 'app/libs/connect';
import { displayedSeries } from 'app/features/success/seriesBlock/selectors';
import S from 'app/features/success/components/Cards.styled';
import SeriesCard from 'app/features/success/seriesBlock/components/SeriesCard';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import { fetchSeriesWithWatchListItems } from 'app/features/success/actions';

const UI = ({ series }) => (
  <S.CardsHolder.Feed>
    {series.map(({ id, name, url, image }, index) => (
      <SeriesCard
        key={id}
        id={id}
        url={url}
        name={name}
        image={image}
        index={index}
      />
    ))}
  </S.CardsHolder.Feed>
);

UI.propTypes = {
  series: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
};

UI.displayName = 'Series';

const state = { series: displayedSeries };

const Series = compose(
  connect(state),
  withDispatchOnMount(fetchSeriesWithWatchListItems),
)(UI);

export { UI };

export default Series;
